import _ from 'underscore';
import { Field } from './field';
import { IJsonSchema } from './types';

// Removed shared types which have been extracted to types.ts

function getNestedList(fields: string[], key: string): string[] {
  return _.chain(fields)
    .filter((field) => field.indexOf(`${key}/`) === 0)
    .map((field) => field.slice(key.length + 1))
    .value();
}

function createField(schema, i18n, fields, override) {
  return _.chain(schema.properties)
    .pick((value, key) => _.find(fields, (field) => field === key || field.indexOf(`${key}/`) === 0))
    .mapObject((value, key) => {
      const prop = _.defaults(value, { required: _.contains(schema.required, key) });

      return value.type === 'object'
        ? _.extend({ prop }, createField(value.schema, i18n, getNestedList(fields, key), override))
        : new Field(prop, i18n, _.result(override, key));
    })
    .value();
}

/**
 * Viewmodel schema, generated from schema file. It provides auto generated
 * default value, validation rules and conversions
 * @param {IJsonSchema} schema - an object which contains property 'properties',
 * @param {I18nModel} i18n - provide callback getString to get localized string
 * @param {string[]} fields - list of fields to read from schema
 * @param {Object} override - Optional override object that changes auto-generated fields
 *
 * Please notice that in schema, required can be defined on either field or schema entity level:
 * @example
 * const schema = {
 *   properties: {
 *     field1: {
 *       type: 'string',
 *       required: true, // required flag on field level
 *     },
 *   },
 *   required: ['fleid2', 'field3'], // required flag on entity level
 * }
 */
export class ViewmodelSchema {
  constructor(
    schema: IJsonSchema,
    i18n: I18nModel,
    fields: string[],
    override?: { [key: string]: any },
  ) {
    const schemaProps = createField(schema, i18n, fields, override);

    _.extend(this, schemaProps);
  }
}
